import React from "react";
import style from "./index.module.scss";
import { Breadcrumb, Spin } from "antd";
import NavBar from "./components/NavBar";
import CourseHeader from "./components/CourseHeader";
import Header from "../Header";

interface CourseLayoutProps {
    children: React.ReactNode;
}

export default function CourseLayout({ children }: CourseLayoutProps) {
    return (
        <div className="PopupContainer">
            <Header />

            <div className={style.container}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>课程内容</Breadcrumb.Item>
                </Breadcrumb>

                <div className={style.body}>
                    <React.Suspense
                        fallback={
                            <Spin>
                                <div style={{ height: 400 }} />
                            </Spin>
                        }>
                        <CourseHeader />

                        <NavBar />

                        <div className={style.main}>{children}</div>
                    </React.Suspense>
                </div>
            </div>
        </div>
    );
}
